module.exports = __webpack_public_path__ + "static/img/body1.f786224.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/onboarding/views/invite/images/animation/body1.png
// module id = oSIX
// module chunks = 12